(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["barra-anuncios-solyvan"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const secciones = document.querySelectorAll('[data-barra-anuncios-solyvan]');

    secciones.forEach(function (seccion) {
      const slides = seccion.querySelectorAll('[data-slide]');
      const anterior = seccion.querySelector('[data-flecha-anterior]');
      const siguiente = seccion.querySelector('[data-flecha-siguiente]');
      const velocidad = parseInt(seccion.getAttribute('data-velocidad'), 10) * 1000 || 4000;
      const autoRotar = seccion.getAttribute('data-auto') === 'true';

      if (slides.length < 2) {
        if (anterior) anterior.style.display = 'none';
        if (siguiente) siguiente.style.display = 'none';
        return;
      }

      let indice = 0;
      let intervalo = null;

      function mostrar(nuevo) {
        slides[indice].classList.remove('barra-anuncios-solyvan__slide--activo');
        indice = (nuevo + slides.length) % slides.length;
        slides[indice].classList.add('barra-anuncios-solyvan__slide--activo');
      }

      function iniciar() {
        if (!autoRotar) return;
        detener();
        intervalo = setInterval(function () { mostrar(indice + 1); }, velocidad);
      }

      function detener() {
        if (intervalo) {
          clearInterval(intervalo);
          intervalo = null;
        }
      }

      if (anterior) {
        anterior.addEventListener('click', function () { mostrar(indice - 1); iniciar(); });
      }

      if (siguiente) {
        siguiente.addEventListener('click', function () { mostrar(indice + 1); iniciar(); });
      }

      seccion.addEventListener('mouseenter', detener);
      seccion.addEventListener('mouseleave', iniciar);

      iniciar();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cabecera-solyvan"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const secciones = document.querySelectorAll('[data-cabecera-solyvan]');

    secciones.forEach(function (seccion) {
      const botonesMenu = seccion.querySelectorAll('[data-toggle-menu]');
      const panelMobile = seccion.querySelector('[data-panel-mobile]');
      const overlay = seccion.querySelector('[data-overlay]');
      const togglesSubmenu = seccion.querySelectorAll('[data-toggle-submenu]');
      const toggleBuscador = seccion.querySelector('[data-toggle-buscador]');
      const buscadorMobile = seccion.querySelector('[data-buscador-mobile]');

      const formulariosBusqueda = seccion.querySelectorAll('[data-cabecera-search-form]');
      const predictiveSearchUrl = seccion.getAttribute('data-predictive-search-url') || '/search/suggest';
      const cacheBusqueda = {};
      const controladoresBusqueda = new WeakMap();

      function cerrarResultadosBusqueda(formulario) {
        const input = formulario.querySelector('[data-cabecera-search-input]');
        const resultados = formulario.querySelector('[data-cabecera-search-results]');
        if (resultados) resultados.hidden = true;
        if (input) {
          input.setAttribute('aria-expanded', 'false');
          input.removeAttribute('aria-busy');
        }
        formulario.removeAttribute('data-cargando-busqueda');
      }

      function mostrarResultadosBusqueda(formulario, html) {
        const input = formulario.querySelector('[data-cabecera-search-input]');
        const resultados = formulario.querySelector('[data-cabecera-search-results]');
        if (!input || !resultados) return;

        resultados.innerHTML = html;
        resultados.hidden = false;
        input.setAttribute('aria-expanded', 'true');
        input.removeAttribute('aria-busy');
        formulario.removeAttribute('data-cargando-busqueda');
      }

      function buscarSugerencias(formulario, termino) {
        const input = formulario.querySelector('[data-cabecera-search-input]');
        if (!input) return;

        if (cacheBusqueda[termino]) {
          mostrarResultadosBusqueda(formulario, cacheBusqueda[termino]);
          return;
        }

        const controladorAnterior = controladoresBusqueda.get(formulario);
        if (controladorAnterior) controladorAnterior.abort();

        const controlador = new AbortController();
        controladoresBusqueda.set(formulario, controlador);
        formulario.setAttribute('data-cargando-busqueda', 'true');
        input.setAttribute('aria-busy', 'true');

        fetch(predictiveSearchUrl + '?q=' + encodeURIComponent(termino) + '&section_id=predictive-search', {
          signal: controlador.signal,
          credentials: 'same-origin'
        })
          .then(function (response) {
            if (!response.ok) throw new Error(response.status);
            return response.text();
          })
          .then(function (text) {
            const documento = new DOMParser().parseFromString(text, 'text/html');
            const seccionResultados = documento.querySelector('#shopify-section-predictive-search');
            const htmlResultados = seccionResultados ? seccionResultados.innerHTML : text;
            cacheBusqueda[termino] = htmlResultados;
            mostrarResultadosBusqueda(formulario, htmlResultados);
          })
          .catch(function (error) {
            if (error && error.name === 'AbortError') return;
            cerrarResultadosBusqueda(formulario);
          });
      }

      formulariosBusqueda.forEach(function (formulario) {
        const input = formulario.querySelector('[data-cabecera-search-input]');
        const resultados = formulario.querySelector('[data-cabecera-search-results]');
        if (!input || !resultados) return;

        let temporizadorBusqueda;

        input.addEventListener('input', function () {
          const termino = input.value.trim();
          window.clearTimeout(temporizadorBusqueda);

          if (termino.length < 2) {
            cerrarResultadosBusqueda(formulario);
            return;
          }

          temporizadorBusqueda = window.setTimeout(function () {
            buscarSugerencias(formulario, termino);
          }, 250);
        });

        input.addEventListener('focus', function () {
          if (input.value.trim().length >= 2 && resultados.innerHTML.trim().length > 0) {
            resultados.hidden = false;
            input.setAttribute('aria-expanded', 'true');
          }
        });

        formulario.addEventListener('submit', function (event) {
          if (!input.value.trim()) event.preventDefault();
        });
      });

      document.addEventListener('click', function (event) {
        formulariosBusqueda.forEach(function (formulario) {
          if (!formulario.contains(event.target)) cerrarResultadosBusqueda(formulario);
        });
      });

      function abrirMenu() {
        if (panelMobile) panelMobile.setAttribute('data-abierto', 'true');
        if (overlay) overlay.setAttribute('data-visible', 'true');
        botonesMenu.forEach(function (btn) { btn.setAttribute('aria-expanded', 'true'); });
        document.body.style.overflow = 'hidden';
      }

      function cerrarMenu() {
        if (panelMobile) panelMobile.removeAttribute('data-abierto');
        if (overlay) overlay.removeAttribute('data-visible');
        botonesMenu.forEach(function (btn) { btn.setAttribute('aria-expanded', 'false'); });
        document.body.style.overflow = '';
      }

      botonesMenu.forEach(function (btn) {
        btn.addEventListener('click', function () {
          const abierto = panelMobile && panelMobile.getAttribute('data-abierto') === 'true';
          if (abierto) {
            cerrarMenu();
          } else {
            abrirMenu();
          }
        });
      });

      if (overlay) {
        overlay.addEventListener('click', cerrarMenu);
      }

      togglesSubmenu.forEach(function (toggle) {
        toggle.addEventListener('click', function () {
          const item = toggle.closest('.cabecera-solyvan__panel-mobile-item');
          if (!item) return;
          const sublista = item.querySelector('.cabecera-solyvan__panel-mobile-sublista');
          if (!sublista) return;
          const abierto = sublista.getAttribute('data-abierto') === 'true';
          if (abierto) {
            sublista.removeAttribute('data-abierto');
            toggle.setAttribute('aria-expanded', 'false');
          } else {
            sublista.setAttribute('data-abierto', 'true');
            toggle.setAttribute('aria-expanded', 'true');
          }
        });
      });

      if (toggleBuscador && buscadorMobile) {
        toggleBuscador.addEventListener('click', function () {
          buscadorMobile.scrollIntoView({ behavior: 'smooth', block: 'start' });
          const input = buscadorMobile.querySelector('input[type="search"]');
          if (input) setTimeout(function () { input.focus(); }, 300);
        });
      }

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') cerrarMenu();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carrusel-productos-solyvan"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const secciones = document.querySelectorAll('[data-carrusel-productos]');

    secciones.forEach(function (seccion) {
      const pista = seccion.querySelector('[data-pista]');
      const anterior = seccion.querySelector('[data-flecha-anterior]');
      const siguiente = seccion.querySelector('[data-flecha-siguiente]');

      if (!pista) return;

      function desplazar(direccion) {
        const tarjeta = pista.querySelector('.carrusel-productos-solyvan__tarjeta');
        if (!tarjeta) return;
        const ancho = tarjeta.getBoundingClientRect().width + 16;
        pista.scrollBy({ left: ancho * direccion * 2, behavior: 'smooth' });
      }

      if (anterior) anterior.addEventListener('click', function () { desplazar(-1); });
      if (siguiente) siguiente.addEventListener('click', function () { desplazar(1); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marcas-solyvan"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const secciones = document.querySelectorAll('[data-marcas-solyvan]');
    secciones.forEach(function (seccion) {
      if (seccion.getAttribute('data-modo') !== 'marquee') return;
      const velocidad = parseInt(seccion.getAttribute('data-velocidad'), 10) || 40;
      const pista = seccion.querySelector('.marcas-solyvan__marquee-pista');
      if (pista) pista.style.setProperty('--velocidad', velocidad + 's');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow-solyvan"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const secciones = document.querySelectorAll('[data-slideshow-solyvan]');

    secciones.forEach(function (seccion) {
      const slides = seccion.querySelectorAll('[data-slide]');
      const puntos = seccion.querySelectorAll('[data-punto]');
      const anterior = seccion.querySelector('[data-flecha-anterior]');
      const siguiente = seccion.querySelector('[data-flecha-siguiente]');
      const velocidad = parseInt(seccion.getAttribute('data-velocidad'), 10) * 1000 || 5000;
      const auto = seccion.getAttribute('data-auto') === 'true';

      if (slides.length < 2) return;

      let indice = 0;
      let intervalo = null;

      function mostrar(nuevo) {
        slides[indice].classList.remove('slideshow-solyvan__slide--activo');
        if (puntos[indice]) puntos[indice].classList.remove('slideshow-solyvan__punto--activo');
        indice = (nuevo + slides.length) % slides.length;
        slides[indice].classList.add('slideshow-solyvan__slide--activo');
        if (puntos[indice]) puntos[indice].classList.add('slideshow-solyvan__punto--activo');
      }

      function iniciar() {
        if (!auto) return;
        detener();
        intervalo = setInterval(function () { mostrar(indice + 1); }, velocidad);
      }

      function detener() {
        if (intervalo) { clearInterval(intervalo); intervalo = null; }
      }

      if (anterior) anterior.addEventListener('click', function () { mostrar(indice - 1); iniciar(); });
      if (siguiente) siguiente.addEventListener('click', function () { mostrar(indice + 1); iniciar(); });

      puntos.forEach(function (punto) {
        punto.addEventListener('click', function () {
          const i = parseInt(punto.getAttribute('data-indice'), 10);
          mostrar(i);
          iniciar();
        });
      });

      seccion.addEventListener('mouseenter', detener);
      seccion.addEventListener('mouseleave', iniciar);

      let startX = 0;
      seccion.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      seccion.addEventListener('touchend', function (e) {
        const diff = e.changedTouches[0].clientX - startX;
        if (Math.abs(diff) > 50) {
          mostrar(diff > 0 ? indice - 1 : indice + 1);
          iniciar();
        }
      }, { passive: true });

      iniciar();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
